function readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(arrayBufferToBase64(reader.result));
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}

// https://gist.github.com/Deliaz/e89e9a014fea1ec47657d1aac3baa83c
function arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
}

export default {
    readFileAsBase64,
};
